import {Link, useLocation} from 'react-router-dom'
import PromptManagerList from '../AIManagerPage/components/PromptManagerList'
import styles from '../AIManagerPage/styles.module.css'

function PromptManagerListPage() {
  const location = useLocation()
  const isHomePath = location.pathname === '/AIManager'
  const isPromptListPath = location.pathname === '/PromptManagerList'

  return (
    <div className={styles.page}>
      <aside className={styles.sideMenu}>
        <p className={styles.menuTitle}>AI Manager</p>
        <Link
          to="/AIManager"
          className={`${styles.menuLink} ${isHomePath ? styles.menuLinkActive : ''}`}
        >
          Home Ai Manager
        </Link>
        <Link to="/PromptManagerList" className={`${styles.menuLink} ${isPromptListPath ? styles.menuLinkActive : ''}`}>
          Prompt Manager
        </Link>
        <Link to="/ChatSocket" className={styles.menuLink}>
          Voltar ao sistema
        </Link>
      </aside>

      <section className={styles.content}>
        <div className={styles.breadcrumb}>
          <Link to="/AIManager" className={styles.breadcrumbLink}>
            AI Manager
          </Link>
          <span className={styles.breadcrumbSep}>/</span>
          <span className={styles.breadcrumbCurrent}>Prompt Manager</span>
        </div>
        <PromptManagerList />
      </section>
    </div>
  )
}

export default PromptManagerListPage

